import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MantineProvider, createTheme } from '@mantine/core';
import '@mantine/core/styles.css';
import { NestedRouter } from 'src/router';
import { OmniverseConfigProvider } from 'src/omniverse/providers';
import { omniverseRoutes } from 'src/omniverse/routes';
import { HttpError } from 'src/omniverse/util/Errors';

// Mantine theme configuration for Omniverse
const omniverseTheme = createTheme({
  fontFamily: 'Open Sans, sans-serif',
  colors: {
    green: [
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
      '#76b900',
    ],
  },
  white: '#fff',
  headings: {
    sizes: {
      h1: {
        fontSize: '48px',
      },
      h2: {
        fontSize: '20px',
      },
    },
    fontWeight: '200',
  },
});

// Query client with retry logic
const omniverseQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: Error) => {
        if (failureCount >= 5 && error instanceof HttpError) {
          if (error.status === 401) {
            // Redirect to login on auth failure
            window.location.href = '/login';
            return false;
          }
        }
        return failureCount < 5;
      },
    },
  },
});

/**
 * SolutionSimulationTab component
 * Renders the Omniverse simulation page within the Solutions context
 * Note: Does not render breadcrumbs as the Solutions page already provides them
 */
function SolutionSimulationTab() {
  return (
    <QueryClientProvider client={omniverseQueryClient}>
      <MantineProvider theme={omniverseTheme} forceColorScheme={'light'}>
        <OmniverseConfigProvider>
          <NestedRouter routes={omniverseRoutes} />
        </OmniverseConfigProvider>
      </MantineProvider>
    </QueryClientProvider>
  );
}

export default SolutionSimulationTab;
